import { FieldProps, getIn } from 'formik';
import * as React from 'react';
import { CreatableInput, IBaseCreatableInputProps } from '../../input';

type InputFieldProps = IBaseCreatableInputProps & FieldProps;

/**
 * Wrapper around CreatableInput to be able to work with Form components
 */
export const CreatableInputField = React.memo<InputFieldProps>(props => {
    const {
        field: { name, value },
        form: { errors, touched: formTouched, setFieldValue },
        ...otherProps
    } = props;

    const error = getIn(errors, name);
    const touched = getIn(formTouched, name);

    const errorMessage: string | undefined = touched && error ? error : undefined;

    const handleChange = (val: string[]): void => {
        setFieldValue(name, val);
    };

    return (
        <CreatableInput value={value} {...otherProps} errorMessage={errorMessage} onChange={handleChange} name={name} />
    );
});
